// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { AccountImage } from './account-image';
import { AddonImage } from './addon-image';
import { ManufacturerImage } from './manufacturer-image';
import { ProductTypeImage } from './product-type-image';
import { SystemImage } from './system-image';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Image extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  // To adhere to the IDoc interface
  get doc(): any {
    return this.data;
  }
  /// </code>

  // Generated code. Do not place code below this line.
  /** Int32 key */
  id!: number;
  /** Binary */
  data!: any;
  /** String(512) */
  fileName!: string;
  /** Boolean */
  isPrimary?: boolean;
  /** Boolean */
  isThumbnail?: boolean;
  /** String(255) */
  mimeType?: string;
  /** Inv FK imageId */
  accountImages!: AccountImage[];
  /** Inv FK imageId */
  addonImages!: AddonImage[];
  /** Inv FK imageId */
  manufacturerImages!: ManufacturerImage[];
  /** Inv FK imageId */
  productTypeImages!: ProductTypeImage[];
  /** Inv FK imageId */
  systemImage!: SystemImage;
}

